import React from "react";
import SEO from "../components/SEO";

const css = `
:root {
 --blue:    #2563EB;
 --blue-d:  #1D4ED8;
 --blue-l:  #EFF6FF;
 --blue-m:  #DBEAFE;
 --dark:    #0A1628;
 --mid:     #1E3A5F;
 --gray:    #475569;
 --lgray:   #64748B;
 --xlgray:  #94A3B8;
 --border:  #E2E8F0;
 --off:     #F8FAFC;
 --white:   #FFFFFF;
 --green:   #10B981;
 --green-l: #D1FAE5;
 --green-d: #065F46;
 --red:     #EF4444;
}
.hipaa-page *,.hipaa-page *::before,.hipaa-page *::after { box-sizing:border-box; margin:0; padding:0 }
.hipaa-page { font-family:'Inter',sans-serif; background:var(--white); color:var(--dark); line-height:1.65; font-size:16px; -webkit-font-smoothing:antialiased; }
@keyframes hipaaPulse { 0%,100%{transform:scale(1)} 50%{transform:scale(1.06)} }
.hipaa-page .site-header { background: rgba(255,255,255,.96); border-bottom: 1px solid var(--border); padding: 18px 24px; position: sticky; top:0; z-index:50; backdrop-filter: blur(12px); }
.hipaa-page .header-inner { max-width: 1180px; margin:0 auto; display:flex; align-items:center; justify-content:space-between; gap:16px; }
.hipaa-page .brand img { height:36px; display:block }
.hipaa-page .back-link { font-size:13px; font-weight:600; color:var(--gray); text-decoration:none; display:flex; align-items:center; gap:6px; transition: color .15s; }
.hipaa-page .back-link:hover { color:var(--blue) }
.hipaa-page .back-link svg { width:14px; height:14px }
.hipaa-page .hero { background: linear-gradient(180deg, #EFF6FF 0%, #fff 100%); padding: 180px 24px 60px; text-align: center; position: relative; }
.hipaa-page .hero::before { content:''; position:absolute; inset:0; background: radial-gradient(ellipse at 50% 0%, rgba(37,99,235,.08) 0%, transparent 70%); pointer-events:none; }
.hipaa-page .hero-inner { max-width: 760px; margin: 0 auto; position:relative; z-index:1 }
.hipaa-page .hero-badge { display: inline-flex; align-items:center; gap:8px; background: #fff; border:1px solid var(--border); border-radius: 100px; padding: 7px 16px; font-size: 12px; font-weight: 700; color: var(--blue); letter-spacing: .5px; margin-bottom: 24px; box-shadow: 0 1px 6px rgba(0,0,0,.05); }
.hipaa-page .hero-badge .dot { width:8px; height:8px; border-radius:50%; background: var(--green); animation: hipaaPulse 2s infinite; }
.hipaa-page .hero h1 { font-size: clamp(32px, 5vw, 52px); font-weight: 900; line-height: 1.1; letter-spacing: -1px; color: var(--dark); margin-bottom: 20px; }
.hipaa-page .hero h1 .blue { color: var(--blue) }
.hipaa-page .hero-sub { font-size: clamp(16px, 2vw, 18px); color: var(--gray); line-height: 1.65; max-width: 620px; margin: 0 auto 32px; }
.hipaa-page .hero-trust { display: flex; align-items:center; justify-content:center; gap:24px; flex-wrap: wrap; font-size: 13px; color: var(--lgray); font-weight:500; }
.hipaa-page .hero-trust-item { display:flex; align-items:center; gap:6px }
.hipaa-page .hero-trust-item svg { color: var(--green); width:14px; height:14px; flex-shrink:0 }
.hipaa-page .badges-strip { background: #fff; padding: 36px 24px; border-bottom: 1px solid var(--border); }
.hipaa-page .badges-inner { max-width: 980px; margin: 0 auto; display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
.hipaa-page .badge-card { display: flex; flex-direction: column; align-items: center; text-align: center; padding: 12px; }
.hipaa-page .badge-icon { width: 48px; height: 48px; border-radius: 12px; background: var(--blue-l); display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
.hipaa-page .badge-icon svg { width: 24px; height: 24px; color: var(--blue) }
.hipaa-page .badge-card .b-title { font-weight: 700; font-size: 14.5px; color: var(--dark); margin-bottom: 3px; line-height: 1.3; }
.hipaa-page .badge-card .b-sub { font-size: 12.5px; color: var(--lgray); line-height: 1.45; }
.hipaa-page .section { padding: 72px 24px }
.hipaa-page .section-inner { max-width: 1080px; margin: 0 auto }
.hipaa-page .section-narrow { max-width: 760px; margin: 0 auto }
.hipaa-page .eyebrow { display: block; text-align: center; font-size: 11px; font-weight: 700; letter-spacing: 2.5px; text-transform: uppercase; color: var(--blue); margin-bottom: 12px; }
.hipaa-page .section-title { font-weight: 800; font-size: clamp(24px, 4vw, 36px); letter-spacing: -.5px; line-height: 1.15; color: var(--dark); text-align: center; margin-bottom: 14px; }
.hipaa-page .section-sub { text-align: center; font-size: 16px; color: var(--gray); line-height: 1.6; max-width: 640px; margin: 0 auto 48px; }
.hipaa-page .pillars-bg { background: var(--off); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border) }
.hipaa-page .pillars { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }
.hipaa-page .pillar { background: #fff; border: 1px solid var(--border); border-radius: 14px; padding: 28px 26px; transition: transform .2s, box-shadow .2s, border-color .2s; }
.hipaa-page .pillar:hover { transform: translateY(-3px); border-color: var(--blue-m); box-shadow: 0 12px 32px rgba(37,99,235,.08); }
.hipaa-page .pillar-icon { width: 44px; height: 44px; border-radius: 10px; background: var(--blue-l); display: flex; align-items: center; justify-content: center; margin-bottom: 18px; }
.hipaa-page .pillar-icon svg { width: 22px; height: 22px; color: var(--blue) }
.hipaa-page .pillar h3 { font-size: 17px; font-weight: 700; color: var(--dark); margin-bottom: 8px; }
.hipaa-page .pillar p { font-size: 14.5px; color: var(--gray); line-height: 1.65; }
.hipaa-page .split-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 40px; }
.hipaa-page .split-card { border-radius: 14px; padding: 28px 26px; }
.hipaa-page .split-card.practice { background: var(--blue-l); border: 1.5px solid var(--blue-m); }
.hipaa-page .split-card.platform { background: var(--green-l); border: 1.5px solid #A7F3D0; }
.hipaa-page .split-h { display: flex; align-items: center; gap: 10px; font-weight: 800; font-size: 17px; margin-bottom: 16px; }
.hipaa-page .split-card.practice .split-h { color: var(--blue-d) }
.hipaa-page .split-card.platform .split-h { color: var(--green-d) }
.hipaa-page .split-h svg { width: 20px; height: 20px; flex-shrink: 0 }
.hipaa-page .split-list { display: flex; flex-direction: column; gap: 10px }
.hipaa-page .split-item { display: flex; align-items: flex-start; gap: 8px; font-size: 14.5px; color: var(--dark); line-height: 1.5; }
.hipaa-page .split-item .dot { flex-shrink: 0; margin-top: 7px; width: 5px; height: 5px; border-radius: 50%; }
.hipaa-page .split-card.practice .dot { background: var(--blue) }
.hipaa-page .split-card.platform .dot { background: var(--green) }
.hipaa-page .commit-list { display: flex; flex-direction: column; gap: 14px; margin-top: 8px }
.hipaa-page .commit-row { display: flex; align-items: flex-start; gap: 14px; background: #fff; border: 1px solid var(--border); border-radius: 12px; padding: 18px 22px; }
.hipaa-page .commit-icon { width: 32px; height: 32px; border-radius: 8px; background: var(--green-l); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.hipaa-page .commit-icon svg { width: 16px; height: 16px; color: var(--green-d) }
.hipaa-page .commit-text strong { display: block; font-size: 15.5px; color: var(--dark); margin-bottom: 3px; font-weight: 700; }
.hipaa-page .commit-text p { font-size: 14px; color: var(--gray); line-height: 1.6; margin: 0; }
.hipaa-page .infra-card { background: #fff; border: 1px solid var(--border); border-radius: 16px; padding: 32px; margin-top: 32px; display: flex; align-items: flex-start; gap: 24px; }
.hipaa-page .infra-logo { width: 56px; height: 56px; border-radius: 12px; background: linear-gradient(135deg, #4285F4 0%, #34A853 50%, #FBBC04 75%, #EA4335 100%); display: flex; align-items: center; justify-content: center; flex-shrink: 0; color: #fff; font-weight: 900; font-size: 22px; }
.hipaa-page .infra-text h3 { font-size: 18px; font-weight: 700; color: var(--dark); margin-bottom: 6px; }
.hipaa-page .infra-text p { font-size: 14.5px; color: var(--gray); line-height: 1.65; margin-bottom: 12px; }
.hipaa-page .infra-text a { font-size: 13.5px; color: var(--blue); font-weight: 600; text-decoration: none; display: inline-flex; align-items: center; gap: 4px; }
.hipaa-page .infra-text a:hover { text-decoration: underline }
.hipaa-page .infra-text a svg { width: 12px; height: 12px }
.hipaa-page .faq-bg { background: var(--off); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border) }
.hipaa-page .faq-list { max-width: 720px; margin: 0 auto }
.hipaa-page details { background: #fff; border: 1px solid var(--border); border-radius: 12px; margin-bottom: 10px; transition: border-color .15s, box-shadow .15s; }
.hipaa-page details[open] { border-color: var(--blue-m); box-shadow: 0 4px 16px rgba(37,99,235,.06); }
.hipaa-page summary { padding: 18px 22px; font-weight: 600; font-size: 15.5px; color: var(--dark); cursor: pointer; list-style: none; display: flex; align-items: center; justify-content: space-between; gap: 14px; }
.hipaa-page summary::-webkit-details-marker { display: none }
.hipaa-page summary::after { content: '+'; font-size: 22px; font-weight: 400; color: var(--lgray); line-height: 1; flex-shrink: 0; transition: transform .2s, color .2s; }
.hipaa-page details[open] summary::after { content: '−'; color: var(--blue) }
.hipaa-page details > p, .hipaa-page details > div { padding: 0 22px 18px; font-size: 14.5px; color: var(--gray); line-height: 1.7; }
.hipaa-page .contact-card { background: linear-gradient(135deg, #2563EB 0%, #1E40AF 100%); border-radius: 16px; padding: 40px; text-align: center; margin-top: 48px; color: #fff; }
.hipaa-page .contact-card h3 { font-size: 22px; font-weight: 800; color: #fff; margin-bottom: 10px; letter-spacing: -.3px; }
.hipaa-page .contact-card p { font-size: 15px; color: rgba(255,255,255,.78); max-width: 480px; margin: 0 auto 22px; line-height: 1.6; }
.hipaa-page .contact-actions { display: flex; justify-content: center; gap: 12px; flex-wrap: wrap; }
.hipaa-page .contact-btn { display: inline-flex; align-items: center; gap: 8px; background: #fff; color: var(--blue-d); padding: 12px 22px; border-radius: 10px; font-weight: 700; font-size: 14.5px; text-decoration: none; transition: transform .15s, box-shadow .15s; }
.hipaa-page .contact-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(0,0,0,.18); }
.hipaa-page .contact-btn.outline { background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,.3); }
.hipaa-page .contact-btn.outline:hover { background: rgba(255,255,255,.1); box-shadow: none }
.hipaa-page .contact-btn svg { width: 14px; height: 14px }
.hipaa-page footer.doc-footer { background: var(--dark); padding: 36px 24px 24px; }
.hipaa-page .foot-inner { max-width: 1180px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; margin-bottom: 24px; }
.hipaa-page .foot-brand { display:flex; align-items:center; gap:10px; text-decoration:none }
.hipaa-page .foot-brand img { height: 26px; filter: brightness(0) invert(1); opacity: .75; }
.hipaa-page .foot-brand span { font-size:13px; color:rgba(255,255,255,.4) }
.hipaa-page .foot-links { display: flex; gap: 22px; flex-wrap: wrap }
.hipaa-page .foot-links a { font-size: 13px; color: rgba(255,255,255,.55); text-decoration: none; transition: color .15s; }
.hipaa-page .foot-links a:hover { color: #fff }
.hipaa-page .foot-bot { max-width: 1180px; margin: 0 auto; border-top: 1px solid rgba(255,255,255,.08); padding-top: 18px; text-align: center; font-size: 12px; color: rgba(255,255,255,.4); }
@media(max-width:900px) {
 .hipaa-page .pillars { grid-template-columns: 1fr 1fr }
 .hipaa-page .badges-inner { grid-template-columns: 1fr 1fr; gap: 28px 16px }
}
@media(max-width:640px) {
 .hipaa-page .site-header { padding: 14px 18px }
 .hipaa-page .brand img { height: 28px }
 .hipaa-page .hero { padding: 140px 20px 40px }
 .hipaa-page .hero-trust { gap: 14px }
 .hipaa-page .badges-strip { padding: 28px 20px }
 .hipaa-page .badges-inner { grid-template-columns: 1fr 1fr; gap: 24px 14px }
 .hipaa-page .section { padding: 52px 20px }
 .hipaa-page .pillars { grid-template-columns: 1fr; gap: 14px }
 .hipaa-page .pillar { padding: 22px 20px }
 .hipaa-page .split-grid { grid-template-columns: 1fr; gap: 14px }
 .hipaa-page .split-card { padding: 22px 20px }
 .hipaa-page .infra-card { flex-direction: column; padding: 24px 20px; gap: 16px }
 .hipaa-page .contact-card { padding: 28px 22px }
 .hipaa-page .contact-actions { flex-direction: column }
 .hipaa-page .contact-btn { width: 100% }
 .hipaa-page .foot-inner { flex-direction: column; align-items: flex-start; gap: 14px }
 .hipaa-page .foot-links { gap: 16px }
}
`;

const Check = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const Hipaa = () => {
  return (
    <div className="hipaa-page">
      <SEO
        title="HIPAA Compliance"
        description="How SmileReveal protects Protected Health Information. HIPAA-compliant architecture for dental practices, with safeguards trusted by compliance officers and IT teams."
      />
      <style>{css}</style>

      <section className="hero">
        <div className="hero-inner">
          <div className="hero-badge">
            <span className="dot"></span>
            HIPAA · BAA Available · Google Cloud Hosted
          </div>
          <h1>Built <span className="blue">HIPAA-compliant</span> from day one.</h1>
          <p className="hero-sub">SmileReveal is built around a privacy-first architecture trusted by dental practices across the U.S. We sign a BAA with every practice, encrypt every image, and never use your patient data to train AI.</p>
          <div className="hero-trust">
            <span className="hero-trust-item"><Check />Encryption in transit &amp; at rest</span>
            <span className="hero-trust-item"><Check />Practice-level tenant isolation</span>
            <span className="hero-trust-item"><Check />BAA executed with every practice</span>
          </div>
        </div>
      </section>

      <section className="badges-strip">
        <div className="badges-inner">
          <div className="badge-card">
            <div className="badge-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
            </div>
            <div className="b-title">HIPAA Compliant</div>
            <div className="b-sub">Built around 45 CFR Parts 160 &amp; 164</div>
          </div>
          <div className="badge-card">
            <div className="badge-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg>
            </div>
            <div className="b-title">Encrypted End-to-End</div>
            <div className="b-sub">In transit &amp; at rest</div>
          </div>
          <div className="badge-card">
            <div className="badge-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12c0 1-2 8-9 8s-9-7-9-8 2-8 9-8 9 7 9 8z" /><circle cx="12" cy="12" r="3" /></svg>
            </div>
            <div className="b-title">Audit Logged</div>
            <div className="b-sub">Every access &amp; action tracked</div>
          </div>
          <div className="badge-card">
            <div className="badge-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
            </div>
            <div className="b-title">Google Cloud Hosted</div>
            <div className="b-sub">Under executed Google BAA</div>
          </div>
        </div>
      </section>

      <section className="section pillars-bg">
        <div className="section-inner">
          <span className="eyebrow">Our 4 Pillars of Compliance</span>
          <h2 className="section-title">How we protect your patient data</h2>
          <p className="section-sub">Every safeguard required by HIPAA — and several that go beyond it — engineered into the platform.</p>

          <div className="pillars">
            <div className="pillar">
              <div className="pillar-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg></div>
              <h3>Encryption everywhere</h3>
              <p>All patient images, generated previews, and account data are encrypted in transit (TLS 1.2+) and at rest using industry-standard AES-256 encryption.</p>
            </div>
            <div className="pillar">
              <div className="pillar-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg></div>
              <h3>Practice-level isolation</h3>
              <p>Your practice's data is logically isolated. No cross-practice access, no shared visibility, no possibility of data bleeding between accounts.</p>
            </div>
            <div className="pillar">
              <div className="pillar-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg></div>
              <h3>30-day default retention</h3>
              <p>Original uploads and generated outputs are retained for 30 days by default, then securely deleted from active systems and backups per retention cycles.</p>
            </div>
            <div className="pillar">
              <div className="pillar-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg></div>
              <h3>Continuous monitoring</h3>
              <p>Real-time security monitoring, documented incident response procedures, and breach notification within HIPAA-defined timelines.</p>
            </div>
            <div className="pillar">
              <div className="pillar-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12l2 2 4-4" /><path d="M21 12c0 5-3.5 7.5-8.5 9-5-.5-8.5-3-8.5-9V5l8.5-3 8.5 3z" /></svg></div>
              <h3>Role-based access controls</h3>
              <p>Granular permissions for owners, doctors, treatment coordinators, and staff. Every user only sees what their role requires — nothing more.</p>
            </div>
            <div className="pillar">
              <div className="pillar-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="9" y1="15" x2="15" y2="15" /><line x1="9" y1="11" x2="15" y2="11" /></svg></div>
              <h3>Full audit logging</h3>
              <p>Every upload, generation, view, share, download, and deletion is logged. Audit logs themselves contain no PHI — they record actions, not patient identities.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-inner">
          <span className="eyebrow">What SmileReveal Collects</span>
          <h2 className="section-title">Designed to minimize PHI from the start</h2>
          <p className="section-sub">SmileReveal works with case references and facial images — not patient identifiers. The less PHI in the system, the lower the risk for everyone.</p>

          <div className="split-grid">
            <div className="split-card platform">
              <div className="split-h"><Check />What we collect</div>
              <div className="split-list">
                <div className="split-item"><span className="dot"></span>Facial images uploaded by the practice</div>
                <div className="split-item"><span className="dot"></span>Generated visual previews and animated smile videos</div>
                <div className="split-item"><span className="dot"></span>Practice-level case references (case number, internal label)</div>
                <div className="split-item"><span className="dot"></span>User account &amp; access information for your team</div>
              </div>
            </div>
            <div className="split-card practice">
              <div className="split-h">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                What we never require
              </div>
              <div className="split-list">
                <div className="split-item"><span className="dot"></span>Patient names</div>
                <div className="split-item"><span className="dot"></span>Dates of birth</div>
                <div className="split-item"><span className="dot"></span>Patient contact information</div>
                <div className="split-item"><span className="dot"></span>Clinical notes or treatment records</div>
                <div className="split-item"><span className="dot"></span>Insurance or billing information</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section pillars-bg">
        <div className="section-inner section-narrow">
          <span className="eyebrow">Our Commitments to You</span>
          <h2 className="section-title">What you can count on, in writing</h2>
          <p className="section-sub">Every promise below is enforced by our Business Associate Agreement and our Privacy Policy.</p>

          <div className="commit-list">
            {[
              ["We sign a BAA with every practice", "A Business Associate Agreement is executed before any PHI touches our platform. Required by HIPAA — and standard practice for us."],
              ["We never train AI on your patient data", "PHI is not used to train, fine-tune, or improve any machine learning or AI models. No exceptions, no fine print."],
              ["We never sell or share PHI for advertising", "Your patient data is yours. We don't sell it, share it for marketing, or use it for any purpose outside of providing the service."],
              ["No cross-practice data sharing or benchmarking", "Each practice's data stays in that practice. We don't aggregate, anonymize-and-share, or benchmark across customers."],
              ["Time-limited, revocable share links", "When you share a smile preview with a patient, the link is time-limited and can be revoked at any time. You stay in control."],
              ["Practice-controlled deletion, anytime", "Delete any image, output, or full case at any time. Deletion removes data from active systems and backups per retention cycles."],
              ["Breach notification within HIPAA timelines", "If a Breach occurs, we notify the affected practice without unreasonable delay — and in no case later than 10 business days after discovery."],
            ].map(([title, body]) => (
              <div key={title} className="commit-row">
                <div className="commit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                </div>
                <div className="commit-text">
                  <strong>{title}</strong>
                  <p>{body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-inner section-narrow">
          <span className="eyebrow">Infrastructure &amp; Subprocessors</span>
          <h2 className="section-title">Where your data lives</h2>
          <p className="section-sub">We're transparent about who handles your data and the agreements that govern that handling.</p>

          <div className="infra-card">
            <div className="infra-logo">G</div>
            <div className="infra-text">
              <h3>Google Cloud Platform</h3>
              <p>SmileReveal is hosted on Google Cloud Platform under an executed HIPAA Business Associate Addendum. Google Cloud is one of the most rigorously certified cloud platforms in the world, with HIPAA, SOC 2, ISO 27001, and FedRAMP attestations.</p>
              <a href="/gcp-baa">View Google Cloud BAA<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg></a>
            </div>
          </div>
        </div>
      </section>

      <section className="section pillars-bg">
        <div className="section-inner section-narrow">
          <span className="eyebrow">Shared Responsibility</span>
          <h2 className="section-title">HIPAA compliance is a partnership</h2>
          <p className="section-sub">SmileReveal provides the secure platform. Your practice controls what data goes in. Here's how we split it.</p>

          <div className="split-grid">
            <div className="split-card practice">
              <div className="split-h">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
                Your practice is responsible for
              </div>
              <div className="split-list">
                <div className="split-item"><span className="dot"></span>Obtaining patient authorizations as required by HIPAA</div>
                <div className="split-item"><span className="dot"></span>Avoiding unnecessary PHI uploads (names, DOBs, contact info)</div>
                <div className="split-item"><span className="dot"></span>Securing user credentials and managing team access</div>
                <div className="split-item"><span className="dot"></span>Responding to patient access &amp; amendment requests</div>
                <div className="split-item"><span className="dot"></span>Compliance with state-specific privacy laws</div>
              </div>
            </div>
            <div className="split-card platform">
              <div className="split-h">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                SmileReveal is responsible for
              </div>
              <div className="split-list">
                <div className="split-item"><span className="dot"></span>Administrative, physical, &amp; technical safeguards</div>
                <div className="split-item"><span className="dot"></span>Encryption, access controls, and tenant isolation</div>
                <div className="split-item"><span className="dot"></span>Audit logging and continuous security monitoring</div>
                <div className="split-item"><span className="dot"></span>Breach detection, response, and notification</div>
                <div className="split-item"><span className="dot"></span>Subcontractor management (Google Cloud BAA)</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section faq-bg">
        <div className="section-inner">
          <span className="eyebrow">Common Questions</span>
          <h2 className="section-title">HIPAA &amp; SmileReveal FAQ</h2>
          <p className="section-sub">Answers your compliance officer, IT team, and legal reviewer will want before signing off.</p>

          <div className="faq-list">
            <details open><summary>Is SmileReveal HIPAA compliant?</summary><p>Yes. SmileReveal is built around a HIPAA-compliant architecture and operates as a Business Associate under a written BAA with each practice. We implement the administrative, physical, and technical safeguards required by 45 CFR §§ 164.308, 164.310, and 164.312.</p></details>
            <details><summary>Will you sign a BAA with our practice?</summary><p>Yes — a Business Associate Agreement is executed with every practice before any PHI is processed. You can review our BAA template at any time. If your practice or DSO requires custom BAA terms, we're happy to review them.</p></details>
            <details><summary>Do you use our patient data to train AI models?</summary><p>No. PHI is never used to train, fine-tune, or improve machine learning or AI models. PHI is not aggregated, benchmarked, or shared across practices. This is contractually committed in our BAA (Section 3.5) and our Privacy Policy.</p></details>
            <details><summary>Where is patient data stored?</summary><p>SmileReveal is hosted on Google Cloud Platform under an executed HIPAA Business Associate Addendum with Google. Data is stored in encrypted form (AES-256 at rest, TLS 1.2+ in transit) within Google Cloud's HIPAA-eligible services.</p></details>
            <details><summary>How long do you retain images and outputs?</summary><p>The default retention period is 30 days for original uploads and generated outputs. Practices can delete data at any time. Upon termination of service, data is returned or destroyed per BAA Section 8, including from backups subject to standard retention cycles.</p></details>
            <details><summary>What happens if there's a Breach?</summary><p>SmileReveal will notify the affected practice without unreasonable delay and in no case later than 10 business days after discovery of a Breach of unsecured PHI. Notifications include the nature of the incident, types of PHI involved, mitigation steps taken, and recommended actions.</p></details>
            <details><summary>What identifiers should we avoid uploading?</summary><p>SmileReveal is designed for use with case references rather than patient identifiers. We recommend not uploading: patient names, dates of birth, contact information, insurance details, or clinical notes. The fewer identifiers in the system, the lower the risk for everyone.</p></details>
            <details><summary>Who can access our practice's data?</summary><p>Only authorized users on your practice's account, governed by role-based access controls you configure. SmileReveal staff access is strictly limited, logged, and only used to support, maintain, secure, and improve the platform — never for marketing or AI training.</p></details>
            <details><summary>Can patients view simulations safely?</summary><p>Yes. Sharing links are time-limited and revocable. You control when and for how long a link is active. Patients access simulations through these links without needing an account, and you can revoke access at any time.</p></details>
            <details>
              <summary>How do I review your full legal documentation?</summary>
              <div>
                <p style={{ marginBottom: 10 }}>Our complete legal documentation is publicly available:</p>
                <p style={{ margin: 0 }}>
                  <a href="/baa" style={{ color: "var(--blue)", fontWeight: 600, textDecoration: "none", display: "block", marginBottom: 4 }}>→ Business Associate Agreement</a>
                  <a href="/privacy" style={{ color: "var(--blue)", fontWeight: 600, textDecoration: "none", display: "block", marginBottom: 4 }}>→ Privacy Policy</a>
                  <a href="/tos" style={{ color: "var(--blue)", fontWeight: 600, textDecoration: "none", display: "block", marginBottom: 4 }}>→ Terms of Service</a>
                  <a href="/gcp-baa" style={{ color: "var(--blue)", fontWeight: 600, textDecoration: "none", display: "block" }}>→ Google Cloud BAA Addendum</a>
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-inner section-narrow">
          <div className="contact-card">
            <h3>Have compliance questions?</h3>
            <p>Our team works with compliance officers, IT teams, and legal reviewers every week. We're happy to answer questions, share documentation, or jump on a call.</p>
            <div className="contact-actions">
              <a href="mailto:compliance@smilereveal.io" className="contact-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                Email compliance team
              </a>
              <a href="/baa" className="contact-btn outline">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
                View our BAA
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="doc-footer">
        <div className="foot-inner">
          <a href="/" className="foot-brand">
            <img
              src="https://assets.cdn.filesafe.space/tKloRW99HBqpfyHkP2PZ/media/69b51709eba487b1413f9072.png"
              alt="SmileReveal"
            />
            <span>Exclusive offer for TIE partner practices</span>
          </a>
          <div className="foot-links">
            <a href="/">About SmileReveal</a>
            <a href="/hipaa">HIPAA Compliance</a>
            <a href="mailto:sales@smilereveal.io">Contact</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/tos">Terms of Service</a>
          </div>
        </div>
        <div className="foot-bot">© 2026 SmileReveal. All rights reserved. Offer exclusively available through The Implant Engine partner program.</div>
      </footer>
    </div>
  );
};

export default Hipaa;
